import FieldConfig from "../../../proto/field-config";
import FieldMultiselect from "../../../generic/multiselect/multiselect";
import {
    CompanyEvent,
    CompanyHoliday,
    EventTypeClass,
    PersonalSickLeave,
    PersonalTravel,
    PersonalVacation,
    ProjectDeadline,
    ProjectEvent,
    ProjectMilestone
} from "../../../../gd/const/event";
import {OptionHeader, OptionSeparator} from "../../../../gd-components/popover-menu/popover-menu/const";
import PopoverMenuItem from "../../../../gd-components/popover-menu/popover-menu/menu-item";
import PopoverMenuOption from "../../../../gd-components/popover-menu/popover-menu/menu-option";

export default class FieldEventTypes extends FieldMultiselect {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel          = "Select event types";

        this.showMenuMore       = false
        this.isSearchable       = false

        this.noValueOptionLabel = 'All'

        this.options            = [
            OptionHeader("Project events"),
            EventTypeClass.toOption(ProjectEvent),
            EventTypeClass.toOption(ProjectMilestone),
            EventTypeClass.toOption(ProjectDeadline),
            OptionSeparator(),

            OptionHeader("Company events"),
            EventTypeClass.toOption(CompanyEvent),
            EventTypeClass.toOption(CompanyHoliday),
            OptionSeparator(),

            OptionHeader("Personal events"),
            EventTypeClass.toOption(PersonalVacation),
            EventTypeClass.toOption(PersonalSickLeave),
            EventTypeClass.toOption(PersonalTravel),

        ]

        this.components = _.assign({}, this.components, {
            PopoverMenuMore             : false,
            PopoverOption               : PopoverMenuOption,
            // PopoverMenu             : FieldSelectField_Popover,
            // FormValueNotEmpty       : FieldSelectField_FormValueNotEmpty,
            // InlineValueNotEmpty     : FieldSelectField_InlineValueNotEmpty,
        })
    }

}